import { useSearchParams } from 'react-router-dom';
import { AUTH_URL, VALID_ACTIONS, WORDPRESS_URL } from 'utils/constants';

interface PublicGuardProps {
  children: JSX.Element;
}

function PublicGuard({ children }: PublicGuardProps) {
  const [searchParams] = useSearchParams();

  const action = searchParams.get('action') ?? '';

  if (!VALID_ACTIONS.includes(action) && !AUTH_URL.includes('localhost')) {
    // window.location.replace(WORDPRESS_URL);
  }

  return children;
}

export default PublicGuard;
